/* created by CoolGuy on 2018/12/13 */
import React from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import { debounce } from '../../utils/util';
import { fixIosFocusProblem } from '../../utils/dom';
import intl from 'react-intl-universal';
@inject('rootStore')
@observer
class VerifyCellphoneModal extends React.Component {
  @observable name = '';
  @observable cellphone = '';
  @observable captcha = '';
  @observable bless = '';
  @observable btnContent = this.captchaWord;
  @computed get captchaWord() {
    return intl.get('send-validate');
  }
  setKeyValue = key => {
    return action(e => {
      this[key] = e.target.value;
    });
  };
  getCaptcha = () => {
    if (this.btnContent !== this.captchaWord) {
      return;
    }
    const { cellphone } = this;
    if (!cellphone || !/^\d{11}$/.test(cellphone)) {
      const { uiStore } = this.props.rootStore;
      uiStore.showAlert(intl.get('Please input the right mobile phone number'));
      return;
    }
    this.sendSms(cellphone);
  };
  sendSms = debounce(cellphone => {
    this.props.rootStore.redPackStore.sendSms(cellphone).then(() => {
      this.setCountDown();
    });
  }, 2000);
  countDownTime = 60;
  setCountDown = () => {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(
      action(() => {
        if (this.countDownTime === 0) {
          this.btnContent = this.captchaWord;
          clearInterval(this.timer);
          this.countDownTime = 60;
        } else {
          this.btnContent = this.countDownTime + 's';
          --this.countDownTime;
        }
      }),
      1000
    );
  };

  closeIt = () => {
    this.props.rootStore.redPackStore.setVerifyModal(false);
  };
  checkMobile = cellphone => {
    if (!cellphone || !/^\d{11}$/.test(cellphone)) {
      return false;
    }
    return true;
  };
  checkInput = () => {
    const { cellphone, name, captcha } = this;
    const { uiStore } = this.props.rootStore;
    if (!this.checkMobile(cellphone)) {
      uiStore.showAlert(intl.get('Please input the right mobile phone number'));
      return false;
    }
    if (!name) {
      uiStore.showAlert(intl.get('Please input name'));
      return false;
    }
    if (!captcha || captcha.length !== 4) {
      uiStore.showAlert(intl.get('Please input the right captcha'));
      return false;
    }
    return true;
  };
  submit = () => {
    const { cellphone, name, captcha, bless } = this;
    if (!this.checkInput()) {
      return;
    }
    const { redPackStore, uiStore } = this.props.rootStore;
    const { verifyModalContent } = redPackStore;
    redPackStore
      .bindPhone({
        phone: cellphone,
        galleryid: verifyModalContent.id,
        content: bless,
        code: captcha,
        nickname: name
      })
      .then(data => {
        const { success, message } = data || {};
        if (!success) {
          uiStore.showAlert(message || intl.get('Something wrong!'));
          return;
        } else {
          uiStore.showToast({
            content: intl.get('Sign up succeed'),
            time: 1000
          });
          setTimeout(() => {
            this.closeIt();
          }, 1000);
        }
      });
  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { redPackStore } = this.props.rootStore;
    const { verifyModalContent } = redPackStore;
    return (
      <div className="verify-cellphone-modal">
        <div className="main-modal">
          <img
            src={require('../../assets/x-20.png')}
            className="x-20"
            onClick={this.closeIt}
            alt=""
          />
          <div className="the-real-main">
            <div style={{ fontSize: 18, color: '#000', marginBottom: 13 }}>
              {intl.get('Sign up to view')}
            </div>
            <div
              style={{
                color: '#000',
                textAlign: 'center'
              }}
            >
              {verifyModalContent.name}
            </div>
            <div className="the-inputs">
              <div className="one-input bb">
                <div className="label">{intl.get('Name')}：</div>
                <input
                  className="value"
                  value={this.name}
                  onChange={this.setKeyValue('name')}
                  placeholder={'请输入'}
                  onBlur={fixIosFocusProblem}
                />
              </div>
              <div className="one-input bb">
                <div className="label">{intl.get('phone')}：</div>
                <input
                  className="value"
                  value={this.cellphone}
                  onChange={this.setKeyValue('cellphone')}
                  placeholder={'请输入'}
                  onBlur={fixIosFocusProblem}
                />
              </div>
              <div className="one-input bb">
                <div className="label" style={{ width: 86 }}>
                  {intl.get('validate')}：
                </div>
                <input
                  className="value"
                  value={this.captcha}
                  onChange={this.setKeyValue('captcha')}
                  onBlur={fixIosFocusProblem}
                />
                <button
                  className={
                    'captcha ' +
                    (this.btnContent === this.captchaWord ? '' : 'waiting')
                  }
                  onClick={this.getCaptcha}
                >
                  {this.btnContent}
                </button>
              </div>
              <div style={{ marginTop: 14, marginBottom: 6 }}>
                {intl.get('Say words')}
              </div>
              <textarea
                placeholder={intl.get('Best wishes')}
                className={'the-textarea'}
                value={this.bless}
                onChange={this.setKeyValue('bless')}
              />
            </div>
            <button className={'submit-btn'} onClick={this.submit}>
              {intl.get('Sign up')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
export default VerifyCellphoneModal;
